import api from '../libs/axios';

export const getShipping = async (params, signal) => {
  const response = await api.get('/shipping', { params, signal });
  return response.data;
};

export const shippingORC = async (dto, signal) => {
  const response = await api.post('/shipping/ocr_bill', dto, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    signal,
  });
  return response.data;
};

export const updateStateShipping = async (params, dto, signal) => {
  const response = await api.patch('/shipping', dto, { params, signal });
  return response.data;
};
